export const handleSearchOverlay = () => {
    const overlay = document.getElementById('search-overlay');

    if (!overlay) return;

    const options = overlay.querySelector('.attrax-search-widget__form-items');
    const location = overlay.querySelector('.location-filter');

    if (!options || !location) return;

    options.appendChild(location);
}